import { tz } from "@date-fns/tz";
import CheckIcon from "@mui/icons-material/Check";
import { Chip, Stack, type Theme, Typography, useMediaQuery } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import { startOfDay } from "date-fns";
import { type Control, Controller, useWatch } from "react-hook-form";
import { actionStatus } from "../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormStatusProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormStatus = ({ control }: IModalActionFormStatusProps) => {
  const { timeZone } = useI18nContext();
  const tablet = useMediaQuery((theme: Theme) => theme.breakpoints.up("tablet"));
  const date = useWatch({
    control,
    name: "date",
  });

  return (
    <Controller
      control={control}
      name="status"
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const displayWarning = value === "todo" && date !== null && date < startOfDay(new Date(), { in: tz(timeZone) });
        return (
          <Stack
            sx={{
              gap: 1,
            }}
          >
            <Stack
              direction={tablet ? "row" : "column"}
              sx={{
                gap: 2,
              }}
            >
              {actionStatus.map((option) =>
                value === option.value ? (
                  <Chip
                    key={option.value}
                    color="primary"
                    icon={<CheckIcon />}
                    label={<Typography variant="body2SemiBold">{option.label}</Typography>}
                    size="small"
                  />
                ) : (
                  <Chip
                    key={option.value}
                    onClick={() => onChange(option.value)}
                    label={<Typography variant="body2">{option.label}</Typography>}
                    size="small"
                  />
                )
              )}
            </Stack>
            <Typography variant="body2" color="error" {...(!error && { display: "none" })}>
              {error?.message}
            </Typography>
            <Typography variant="caption" color="primary" {...(!displayWarning && { display: "none" })}>
              Attention : la date et le statut ne sont pas cohérents.
            </Typography>
          </Stack>
        );
      }}
    />
  );
};
